import { Order } from '~src/ts/helpers/Order';
import { OrderKeys } from '~src/ts/models/OrderKeys';
import { SortOptions } from '~src/ts/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/ts/models/sort/SortOptionDefinitions';

export const collectionItemPositionSortOrder = [Order.asc(OrderKeys.position)];

export const collectionItemDateSortOrder = [Order.desc(OrderKeys.dateAdded)];

export const collectionItemsSpecificSortOptions: OptionsDictionary = {
  'position': SortOptions.position,
  'dateAdded': SortOptions.dateAdded
};

export const collectionItemsSpecificSortOptionsWithoutCustomSort: OptionsDictionary = {
  'dateAdded': SortOptions.dateAdded
};

export const collectionItemsMixedContentOptionsBase: OptionsDictionary = {
  'name': SortOptions.name,
  'type': SortOptions.type,
  'owner': SortOptions.mixedContentOwner,
  'updated': SortOptions.updated,
};
